import {defineMessages, FormattedMessage} from 'react-intl';

const messages = defineMessages({
  contentTitleAdd: {
    id: 'constants.person-groups.contentTitleAdd',
    defaultMessage: 'Add Group',
  },
  contentTitleEdit: {
    id: 'constants.person-groups.contentTitleEdit',
    defaultMessage: 'Edit Group',
  },
  contentTitleDuplicate: {
    id: 'constants.person-groups.contentTitleDuplicate',
    defaultMessage: 'Duplicate Group',
  },
  add: {
    id: 'constants.person-groups.add',
    defaultMessage: 'Add Group',
  },
  save: {
    id: 'constants.person-groups.save',
    defaultMessage: 'Save',
  },
});

export const GROUP_ACTIONS = {
  ADD: 'add',
  DUPLICATE: 'duplicate',
  EDIT: 'edit',
};

export const MODAL_TITLE = {
  duplicate: <FormattedMessage {...messages.contentTitleDuplicate} />,
  add: <FormattedMessage {...messages.contentTitleAdd} />,
  edit: <FormattedMessage {...messages.contentTitleEdit} />,
};

export const BUTTON_TEXT = {
  save: <FormattedMessage {...messages.save} />,
  add: <FormattedMessage {...messages.add} />,
};

export const GROUP_MEMBER_CONSTANTS = {
  QUICK_SEARCH: 'quickSearch',
  NAME: 'name',
  EMAIL: 'email',
  ORGANIZATION: 'organization',
};
export const GROUP_MEMBER_COLUMN_KEYS = {
  NAME: 'lastName',
  EMAIL: GROUP_MEMBER_CONSTANTS.EMAIL,
  ORGANIZATION: GROUP_MEMBER_CONSTANTS.ORGANIZATION,
};

// https://bitbucket.org/crisis24/wc4-api-docs/src/master/src/docs/private/person-group/wc4-person-group-ms.yaml#lines-1094
export const GROUP_CONSTANTS = {
  QUICK_SEARCH: 'searchText',
  NAME: 'name',
  DESCRIPTION: 'description',
  ORGANIZATION_ID: 'organizationId',
  PERSON_COUNT: 'personCount',
  LAST_UPDATED: 'lastUpdated',
  CREATED_BY: 'createdBy',
  FILTER_SEARCH_MINIMUM_LENGTH: 3,
};

export const GROUP_COLUMN_KEYS = {
  NAME: GROUP_CONSTANTS.NAME,
  DESCRIPTION: GROUP_CONSTANTS.DESCRIPTION,
  PERSON_COUNT: GROUP_CONSTANTS.PERSON_COUNT,
  LAST_UPDATED: 'updatedAt',
  CREATED_BY: GROUP_CONSTANTS.CREATED_BY,
};

// https://bitbucket.org/crisis24/wc4-api-docs/src/master/src/docs/private/person-group/wc4-person-group-ms.yaml#lines-1164
export const GROUP_SEARCH_KEYS = {
  IDS: 'ids',
  ORGANIZATION_IDS: 'organizationIds',
  PERSON_IDS: 'personIds',
  SEARCH_TEXT: 'searchText',
};

// https://bitbucket.org/crisis24/wc4-api-docs/src/master/src/docs/private/person-group/wc4-person-group-ms.yaml#lines-1146
export const GROUP_PERSON_SEARCH_KEYS = {
  PERSON_IDS: 'personIds',
  QUICK_SEARCH_TEXT: 'quickSearchText',
};

export const DATE_RANGE_TYPE = {
  STATIC: 'STATIC',
  RELATIVE: 'RELATIVE',
};
